import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import mutationDocument from "./initializeCartPaymentMutation.graphql";
import type {
  InitializeCartPaymentResultTypeTl,
  InputInitializeCartPaymentTypeTl,
  Mutations,
  MutationsInitializeCartPaymentTlArgs,
} from "@/core/api/graphql/types";

export async function initializeCartPayment(
  cartId: string,
  dataAreaId: string,
): Promise<InitializeCartPaymentResultTypeTl> {
  const { storeId, cultureName, userId } = globals;
  const payload = <InputInitializeCartPaymentTypeTl>{
    cartId,
    storeId: storeId,
    cultureName: cultureName,
    dataAreaId: dataAreaId,
    storefrontUrl: location.origin,
    userId: userId,
  };
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "initializeCartPaymentTL">>,
    MutationsInitializeCartPaymentTlArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: payload,
    },
  });
  return data!.initializeCartPaymentTL;
}
